import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import { useMemo } from 'react';
import { compareMonth, compareString } from '@/modules/finances/lib/budget-statement-utils';
import type { BudgetStatement, SortOptionValue } from '@/modules/finances/types';
interface UseBudgetStatementDataProps {
  budgetStatements: BudgetStatement[];
  sortOption?: SortOptionValue;
}
const SORTERS: Record<SortOptionValue, (a: BudgetStatement, b: BudgetStatement) => number> = {
  reporting_newest: (a, b) => compareMonth(b.month, a.month),
  reporting_oldest: (a, b) => compareMonth(a.month, b.month),
  modified_newest: (a, b) => compareString(b.lastModifiedAtUtcIso, a.lastModifiedAtUtcIso),
  modified_oldest: (a, b) => compareString(a.lastModifiedAtUtcIso, b.lastModifiedAtUtcIso)
};
export function useBudgetStatementData(t0) {
  const $ = _c(9);
  const {
    budgetStatements,
    sortOption
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsArrayOf(parseAsString);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedStatuses] = useQueryState("status", t1);
  let t2;
  if ($[1] !== budgetStatements || $[2] !== selectedStatuses || $[3] !== sortOption) {
    bb0: {
      let result = budgetStatements;
      if (selectedStatuses && selectedStatuses.length > 0) {
        let t3;
        if ($[5] !== selectedStatuses) {
          t3 = statement => selectedStatuses.includes(statement.status);
          $[5] = selectedStatuses;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        result = result.filter(t3);
      }
      if (sortOption && result.length > 0) {
        const sortFn = SORTERS[sortOption];
        t2 = [...result].sort(sortFn);
        break bb0;
      }
      t2 = result;
    }
    $[1] = budgetStatements;
    $[2] = selectedStatuses;
    $[3] = sortOption;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const processedBudgetStatements = t2;
  let t3;
  if ($[7] !== processedBudgetStatements) {
    t3 = {
      processedBudgetStatements
    };
    $[7] = processedBudgetStatements;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}